/* Extracted from sections/main-collection-product-grid.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

(function () {
    const trigger = document.getElementById('MobileFilterTrigger');
    const drawer = document.getElementById('MobileFilterDrawer');
    const closeBtn = drawer?.querySelector('.mobile-filter-drawer__close');
    const submitBtn = drawer?.querySelector('.mobile-filter-drawer__submit');

    if (!trigger || !drawer) return;

    trigger.addEventListener('click', function () {
      drawer.showModal();
    });

    closeBtn?.addEventListener('click', function () {
      drawer.close();
    });

    submitBtn?.addEventListener('click', function () {
      drawer.close();
    });

    drawer.addEventListener('click', function (e) {
      if (e.target === drawer) {
        drawer.close();
      }
    });
  })();
